module.exports = __webpack_public_path__ + "img/dpl.12c128b4.png";